import { render, staticRenderFns } from "./ImagesPreview.vue?vue&type=template&id=5bd3e02a&scoped=true"
import script from "./ImagesPreview.vue?vue&type=script&lang=ts"
export * from "./ImagesPreview.vue?vue&type=script&lang=ts"
import style0 from "./ImagesPreview.vue?vue&type=style&index=0&id=5bd3e02a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3e02a",
  null
  
)

export default component.exports